import { memo } from 'react';
import { Pagination } from 'antd';
import { useTranslate } from '@tolgee/react';
import { useSearchContext, useItemContext } from '../Context';

export const ListPagination = memo(() => {
  const { t } = useTranslate();
  const { pageNo, pageSize, setParams } = useSearchContext();
  const { total } = useItemContext();
  return (
    <Pagination
      showSizeChanger
      showQuickJumper
      showTotal={(x) => t('feedback.共x项', { x })}
      pageSizeOptions={['10', '20', '50', '100']}
      total={total}
      pageSize={pageSize}
      current={pageNo}
      onChange={(page, pageSize) => {
        setParams({ pageNo: page, pageSize });
      }}
    />
  );
});

ListPagination.displayName = 'ItemSelectV5ListPagination';
